import { Routes } from '@all-hands-hq/plex-graphql-schema';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { GetLoggedInUserQuery } from '../../../../graphql/gen/types';
import { usePlexes } from '../../../../models/filters/useSelectedPlexIds';
import { rightBorderStyle, topBorderStyle } from '../../../../theme';
import { PlexesSection } from './PlexesSection';
import { UserSection } from './UserSection';

interface Props {
  userProfile: NonNullable<GetLoggedInUserQuery['currentUser']>;
}

export function FilterLeftNavBar({ userProfile }: Props): React.ReactElement {
  const classes = useStyles();
  const plexes = usePlexes();
  const history = useHistory();

  if (!plexes) {
    return <div>Loading...</div>;
  }

  return (
    <div className={classes.drawerPaper}>
      <div className={classes.drawerScrollableContent}>
        <div className={classes.drawerScrollableTop}>
          <PlexesSection plexes={plexes} />
        </div>
        <div className={classes.drawerFixedBottom}>
          <UserSection
            userProfile={userProfile}
            onClick={() => {
              history.push(Routes.GENERAL_SETTINGS_PATH);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export const FILTER_LEFT_NAVBAR_WIDTH = 260;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerPaper: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      // Place drawer under the top navbar
      zIndex: theme.zIndex.appBar - 1,
      width: FILTER_LEFT_NAVBAR_WIDTH,
      backgroundColor: '#fff',
      overflow: 'hidden',
      ...rightBorderStyle,
    },
    drawerScrollableContent: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: 1,
    },
    drawerScrollableTop: {
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    drawerFixedBottom: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      ...topBorderStyle,
    },
  })
);
